<script>
  import { onMount } from 'svelte';
  import { link } from "svelte-routing";
  import { default as Pagination } from "./../../../components/Pagination.svelte";
  import { default as CategoryFilter } from "./../../../components/knowledge/CategoryFilter.svelte";
  
  export let json_url = "";
  export let query_string = "";
  export let category_ids = [];
  export let base_category_ids = [];
  
  let page = 1;
  let per_page = 10;
  let hot = true;
  let url = "";
  let subjects = [];
  let count = 0;
  
  $: categoryFilterSelected = category_ids.reduce((acc,curr)=>(acc[curr]=true,acc),{});
  
  function load() {
    if (isNaN(parseInt(+page))) return;
    let newurl = json_url+"?page="+page+queryString();
    if (newurl === url) return;
    url = newurl;
    hot = false;
    fetch(url)
      .then(r => r.json())
      .then(data => {
        if (data.data) {
          subjects = data.data.length ? data.data : [];
          if (data.count == 1)
            subjects = [data.data];
          count = data.count;
        } else {
          subjects = [];
          count = 0;
        }
        window.scrollTo(0, 0);
    });
  }
  
  function allCategoryIds() {
    if (category_ids.length)
      return category_ids;
    else
      return base_category_ids;
  }
  
  function queryString() {
    let categories_string = "";
    if (base_category_ids.length || category_ids.length)
      categories_string = "&categories="+allCategoryIds().join('+');
    return query_string + categories_string;
  }
  
  function setPage(p) {
    if (page == p)
      return;
    page = p;
    load();
  }
  
  function setCategory(e) {
    let i = category_ids.indexOf(e.detail.category_id);
    if (i < 0 && e.detail.value)
      category_ids.push(e.detail.category_id);
    else if (!e.detail.value)
      category_ids.splice(i, 1);
    load();
  }
  
  
  onMount(load);
</script>

<div class='row'>
<div class='col-3'>
<div class='px-0 py-4' id='company-filter'>
<CategoryFilter root_id="{base_category_ids[0]}" json_url="/kategorie.json" include_root="{false}" on:setCategory="{setCategory}" filtered="{categoryFilterSelected}" />
</div>
</div>
<div class='col-9'>
<div class='row align-items-end mb-3'>
<div class='col-12'>
{#if count}
<Pagination totalItems="{count}" pageSize="{per_page}" currentPage="{page}" limit="{1}" showStepOptions="{true}" on:setPage="{(e) => setPage(e.detail.page)}" />
{/if}
</div>
</div>
{#each subjects as {content, name, id, rating} }
<div class='card mb-3 overflow-hidden shadow' style='max-width: 100%'>
{#if content}
<div class='row'>
<div class='d-flex align-items-center justify-content-center col-md-4 pt-sm-0 pt-md-0 cpmpany-bg text-center' style='background-size: cover; background-position-center: center; background-image: url(/img/wine.jpg);'>
<img alt='{ name }' class='img-fluid' src='/img/logo.jpg' title='{ name }'>
</div>
<div class='col-md-8'>
<div class='card-body justify-content-start'>
<h3 class='card-title text-dark font-weight-bold'>{ name }</h3>
<h5 class='mb-3 card-text text-dark font-weight-normal'>
{#if  content.City }{content.City}{/if}
{#if  content.Street }, {content.Street}{/if}
</h5>
<ul class='list-inline'>
{#if content.Hours}
<li class='list-inline-item' title='Otevírací doba'>
<span class='badge badge-pill badge-dark'>
<span class='h5'>
<span class='fa fa-clock-o'></span>
<span>{content.Hours}</span>
</span>
</span>
</li>
{/if}
{#if content.Wines}
<li class='list-inline-item' title='Vína'>
<span class='badge badge-pill badge-success'>
<span class='h5'>
<span class='fa fa-glass'></span>
<span>{ content.Wines }</span>
</span>
</span>
</li>
{/if}
{#if content.Capacity}
<li class='list-inline-item' title='Kapacita'>
<span class='badge badge-pill badge-success'>
<span class='h5'>
<span class='fa fa-user'></span>
<span>{ content.Capacity }</span>
</span>
</span>
</li>
{/if}
{#if content.Beds}
<li class='list-inline-item' title='Ubytování'>
<span class='badge badge-pill badge-success'>
<span class='h5'>
<span class='fa fa-bed'></span>
<span>{ content.Beds }</span>
</span>
</span>
</li>
{/if}
{#if content.Office}
<li class='list-inline-item' title='Pobočky'>
<span class='badge badge-pill badge-success'>
<span class='h5'>
<span class='fa fa-home'></span>
<span>{ content.Office }</span>
</span>
</span>
</li>
{/if}
{#if content.Photos}
<li class='list-inline-item' title='Galerie'>
<span class='badge badge-pill badge-success'>
<span class='h5'>
<span class='fa fa-camera'></span>
<span>{content.Photos}</span>
</span>
</span>
</li>
{/if}
{#if rating}
<li class='list-inline-item' title='Popularita'>
<span class='badge badge-pill badge-success'>
<span class='h5'>
<span class='fa fa-heart'></span>
<span>{rating}</span>
</span>
</span>
</li>
{/if}
{#if content.Uri}
<li class='list-inline-item' title='Webové stránky'>
<a class='badge badge-pill badge-success' href='{content.Url}'>
<span class='h5'>
<i class='fa fa-link'></i>
</span>
</a>
</li>
{/if}
{#if content.email}
<li class='list-inline-item' title='E-mail'>
<a class='badge badge-pill badge-success h5' href='mailto: {content.email}'>
<span class='h5'>
<i class='fa fa-envelope'></i>
</span>
</a>
</li>
{/if}
</ul>
{#if content.About}
<p class='card-text font-normal text-body'>{content.About}</p>
{/if}
<a alt='Více...' class='btn btn-dark' href='/firma/{id}' title='Detail provozovny' use:link>
<span class='element-style' style='letter-spacing: 0px;'>
<span>Detail</span>
</span>
<span class='element-style' style='letter-spacing: -4px;'>
<i class='fa fa-chevron-right'></i>
<i class='fa fa-chevron-right'></i>
<i class='fa fa-chevron-right'></i>
</span>
</a>
</div>
</div>
</div>
{/if}
</div>
{/each}
<div class='row align-items-end mt-3'>
<div class='col-12'>
{#if count}
<Pagination totalItems="{count}" pageSize="{per_page}" currentPage="{page}" limit="{1}" showStepOptions="{true}" on:setPage="{(e) => setPage(e.detail.page)}" />
{/if}
</div>
</div>
</div>
</div>

